import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import useRefetchWhenChangeId from '../useRefetchWhenChangeId/useRefetchWhenChangeId'
import { addNewElements, getSavedNavigation, saveNavigation } from './helpers'

const useNavigateBetweenElements = ({
  currentId,
  fetchDetailElement,
  fetchElements,
  fetchTimeLine,
  elementDetailRoute,
  selectedStoreId,
  filtersInContext,
  elementsInContext,
  updateContext,
  nameOfElementsInContext,
  nameOfFiltersInContext,
}) => {
  const navigation = useNavigate()
  const hasElementsInContext = Boolean(elementsInContext?.results.length)

  useRefetchWhenChangeId(currentId, fetchDetailElement, fetchTimeLine)

  useEffect(() => {
    if (!hasElementsInContext || !filtersInContext) return

    saveNavigation({
      nameOfElementsInContext,
      nameOfFiltersInContext,
      elements: elementsInContext,
      filters: filtersInContext,
    })
  }, [elementsInContext, filtersInContext, hasElementsInContext, nameOfElementsInContext, nameOfFiltersInContext])

  useEffect(() => {
    if (hasElementsInContext) return

    const savedNavigation = getSavedNavigation(nameOfElementsInContext, currentId)

    if (!savedNavigation) return

    updateContext(context => ({ ...context, ...savedNavigation }))
  }, [currentId, hasElementsInContext, nameOfElementsInContext, updateContext])

  const onNavigateToElementDetail = element => {
    if (element) {
      navigation(elementDetailRoute.replace(':id', element.id))
    }
  }

  const onGetMoreElements = async direction => {
    const response = await fetchElements({
      storeId: selectedStoreId,
      params: {
        ...filtersInContext,
        cursor: direction === 'prev' ? filtersInContext.prevCursor : filtersInContext.nextCursor,
      },
    })

    const results = addNewElements(direction, elementsInContext.results, response.data.results)
    const previous = direction === 'prev' ? response.data.previous : elementsInContext.previous
    const next = direction === 'next' ? response.data.next : elementsInContext.next

    updateContext(context => ({
      ...context,
      [nameOfElementsInContext]: { ...response.data, results, previous, next },
      [nameOfFiltersInContext]: { ...context[nameOfFiltersInContext], prevCursor: previous, nextCursor: next },
    }))

    return results
  }

  return {
    onNavigateToElementDetail,
    onGetMoreElements,
  }
}

export default useNavigateBetweenElements
